module.exports = __webpack_public_path__ + "static/media/YF101_2.9afafc4b.jpg";